(function () {
    'use strict';

    var module = angular.module('uwAgenda.version');
    module.directive('versionInfo', ['AppConfig', 'VersionService', VersionInfoFn]);

    /* version info directive */
    function VersionInfoFn(AppConfig, VersionService) {
        var directive = {
            restrict: 'E',
            link: link,
            template: '<span>v{{feVersion}} - API v{{apiVersion}}</span>'
        };
        return directive;

        function link(scope, element) {

            scope.feVersion = AppConfig.version;
            VersionService.getApiVersion().then(function(response) {
                scope.apiVersion = response;
            });
        }
    }
})();